/*
=========================================================
* Material Kit 2 React - v2.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-kit-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// @mui material components

import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
import Icon from "@mui/material/Icon";

// Material Kit 2 React components
import MKBox from "components/MKBox";

import MKTypography from "components/MKTypography";

// Images

function Profile() {
  return (
    <MKBox component="section" py={{ xs: 12, sm: 12 }}>
      <Container>
        <Grid container item xs={12} justifyContent="center" mx="auto">
          <Grid container justifyContent="center" py={6}>
            <Grid item xs={12} md={10} mx={{ xs: "auto", sm: 6, md: 1 }}>
              <MKBox display="flex" justifyContent="space-between" alignItems="center" mb={1}>
                <MKTypography variant="h3">Denuncias</MKTypography>
              </MKBox>

              <MKTypography variant="body1" fontWeight="light" color="text">
                <p style={{ padding: "9px 0" }}>
                  En la provincia de San Juan, una parte importante de los trabajadores y
                  trabajadoras de panaderías continúa desempeñándose en condiciones de informalidad.
                  Se estima que alrededor del{" "}
                  <strong>45% del personal está trabajando sin registración</strong>, una situación
                  que como sindicato enfrentamos y combatimos todos los días.
                </p>
                <p style={{ padding: "9px 0" }}>
                  La informalidad laboral no solo significa cobrar menos de lo que corresponde, sino
                  que también implica la pérdida de derechos fundamentales que protegen tu salud, tu
                  dignidad y el bienestar de tu familia. Cuando trabajás “en negro” quedás excluido
                  de beneficios esenciales como:
                </p>
                <strong style={{ padding: "9px 0" }}>
                  <ul style={{ marginLeft: "1.5rem", lineHeight: "1.8rem" }}>
                    <li>Obra social para vos y tu familia.</li>
                    <li>Aportes jubilatorios y años de antigüedad reconocidos.</li>
                    <li>Seguro de vida y cobertura ante accidentes laborales.</li>
                    <li>Vacaciones pagas y licencias correspondientes por ley.</li>
                    <li>Pago de horas extra, feriados y adicionales según convenio.</li>
                    <li>Entrega de uniforme y elementos de seguridad en condiciones.</li>
                    <li>
                      Recibir el <strong>kilo de pan diario</strong> establecido en el convenio.
                    </li>
                    <li>Estabilidad laboral y protección contra despidos injustificados.</li>
                  </ul>
                </strong>
                <p style={{ padding: "9px 0" }}>
                  Sabemos que tu trabajo es valioso y que detrás de vos hay una familia que depende
                  de tu esfuerzo. Por eso, desde el{" "}
                  <strong>Sindicato de Obreros Panaderos y Pasteleros de San Juan</strong> te
                  invitamos a realizar tu denuncia de forma segura y confidencial. Nuestro objetivo
                  no es generar despidos, sino ayudarte a regularizar tu situación, garantizar que
                  tu salario sea el que marca la ley y que puedas crecer dentro de tu lugar de
                  trabajo con los derechos que te corresponden.
                </p>
                <p style={{ padding: "9px 0" }}>
                  <strong>No estás solo.</strong> Estamos para acompañarte y defender tus derechos.
                </p>{" "}
                <br />
                <MKTypography
                  component="a"
                  href="/formulariodenuncia"
                  variant="body1"
                  fontWeight="light"
                  color="info"
                  mt={3}
                  sx={{
                    width: "max-content",
                    display: "flex",
                    alignItems: "center",

                    "& .material-icons-round": {
                      transform: `translateX(3px)`,
                      transition: "transform 0.2s cubic-bezier(0.34, 1.61, 0.7, 1.3)",
                    },

                    "&:hover .material-icons-round, &:focus .material-icons-round": {
                      transform: `translateX(6px)`,
                    },
                  }}
                >
                  Realizar Denuncia <Icon sx={{ fontWeight: "bold" }}>arrow_forward</Icon>
                </MKTypography>
              </MKTypography>
            </Grid>
          </Grid>
        </Grid>
      </Container>
    </MKBox>
  );
}

export default Profile;
